/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, FormControl, HFlow, Icon, VFlow } from 'bold-ui'
import { CheckboxField } from 'components/form/final-form/CheckboxField'
import { ErrorField } from 'components/form/final-form/ErrorField'
import { CondutaOdontoEnum, TipoConsultaOdontoEnum } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'

export interface CondutaOdontoPanelProps {
  name: MetaPath<CondutaOdontoEnum[]>
  tipoConsulta?: TipoConsultaOdontoEnum
}

export function CondutaOdontoPanel(props: CondutaOdontoPanelProps) {
  const { name, tipoConsulta } = props
  const tipoConsultaNullOrManutencao = !tipoConsulta || tipoConsulta === TipoConsultaOdontoEnum.CONSULTA_DE_MANUTENCAO

  return (
    <FormControl label='Conduta' required>
      <VFlow vSpacing={0.5}>
        <ErrorField name={name} />

        <HFlow
          hSpacing={4}
          style={css`
            margin-left: -0.25rem;
          `}
        >
          <VFlow vSpacing={0.5}>
            <CheckboxField
              name={name}
              label='Tratamento concluido'
              value={CondutaOdontoEnum.TRATAMENTO_CONCLUIDO}
              disabled={tipoConsultaNullOrManutencao}
            />

            <CheckboxField name={name} label='Agendamento para grupos' value={CondutaOdontoEnum.AGENDAMENTO_P_GRUPOS} />

            <CheckboxField name={name} label='Agendamento para NASF' value={CondutaOdontoEnum.AGENDAMENTO_P_NASF} />

            <CheckboxField
              name={name}
              label='Alta do episódio'
              value={CondutaOdontoEnum.ALTA_DO_EPISODIO}
              disabled={!tipoConsultaNullOrManutencao}
            />
          </VFlow>

          <VFlow vSpacing={0.5}>
            <CheckboxField
              name={name}
              label='Retorno para consulta agendada'
              value={CondutaOdontoEnum.RETORNO_PARA_CONSULTA_AGENDADA}
            />

            <CheckboxField
              name={name}
              label='Agendamento para outros profissionais ab'
              value={CondutaOdontoEnum.AGENDAMENTO_P_OUTROS_PROFISSIONAIS_AB}
            />

            <Button
              kind='primary'
              skin='outline'
              size='small'
              onClick={(event) => {}}
              style={css`
                margin-left: 0.25rem;
              `}
            >
              <Icon icon='calendarOutline' /> Agendar consulta
            </Button>
          </VFlow>
        </HFlow>
      </VFlow>
    </FormControl>
  )
}
